import React from 'react'
import Link from 'gatsby-link'
import './header.scss'
import siteLogo from "../../../images/logo.png";

const Header = ({ siteTitle }) => (
  <div className="header-container">
  <div className="header-content-container">
  <div className="container">
  <div className="row">
  <div className="col-12">
 <Link to="/" >
  <img alt="Curveball Logo" className="header-logo" src={siteLogo} />
  <span>
  Curveball
  </span>
  </Link>
  <Link to="/partners" className="header-link" activeClassName="is-active">Partners</Link>
  </div>
  </div>
  </div>
  </div>
  </div>
  )

export default Header



// WEBPACK FOOTER //
// ./src/components/global/header/header.js